class LocalizationForm extends HTMLElement {
  elements = {};

  constructor() {
    super();
    this.elements = {
      form: this.querySelector('.locale-selector'),
      input: this.querySelector('[name="locale_code"]'),
      options: this.querySelectorAll('[lang-option]'),
      select: this.querySelector('select'),
    };

    this.elements.select.addEventListener('change', this.handleSelectChange);
  }


  handleSelectChange = (event) => {
    event.preventDefault();
    const { target } = event;
    const { value } = target;
    this.elements.input.value = value;
    this.elements.select.value = value;

    if (this.elements.form)
      this.elements.form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);


class PopupPromo extends HTMLElement {
  constructor() {
    super();

    this.properties = {
      account_owner: this.getAttribute('account_owner'),
      active: this.getAttribute('active'),
      form_id: this.getAttribute('form_id'),
      time_to_show: this.getAttribute('time_to_show'),
      cookie_lifetime: this.getAttribute('cookie_lifetime'),
      cookie_name: `${this.getAttribute('form_id')}_consumned`
    }

    this.elements = {
      overlay: this.querySelector('.popup-promo__overlay'),
      closeButton: this.querySelector('.popup-promo__close'),
      modalForm: this.querySelector('.popup-promo__modal_form'),
      modalCode: this.querySelector('.popup-promo__modal_code'),
    };

    this._run()
  }

  _run = () => {
    if (!this.shoudlRun()) {
      this.destroyModal()
      return
    }


    this.runModal()
    this.elements.closeButton.addEventListener('click', this.handleCloseButtonClick);
    this.elements.overlay.addEventListener('click', this.handleCloseButtonClick);


    // this.elements.form.addEventListener('submit', this.handleFormSubmit);
  }

  shoudlRun = () => {

    //check if active
    if (!this.checkIfActive())
      return false;

    if (this.checkIfAccountOwner())
      return false;

    //check if is a challenge page
    if (this.checkIfChallenge())
      return false;

    //check if is a challenge page
    if (this.checkIfIsThanksModal()) {
      return true
    }

    //check if cookie exists
    if (document.cookie.indexOf(this.properties.cookie_name) > -1)
      return false;

    return true;
  }

  runModal = () => {
    if (this.checkIfIsThanksModal()) {
      this.showModal()
      this.addCookie(true);
      return
    }

    setTimeout(() => this.showModal(), this.properties.time_to_show * 1000)
  }



  checkIfAccountOwner = () => {
    const { account_owner } = this.properties;

    if (account_owner === 'false')
      return false;

    return true;
  }

  checkIfActive = () => {
    const { active } = this.properties;

    if (active === '0' || !active)
      return false;

    return true;
  }

  checkIfChallenge = () =>
    window.location.href.indexOf("/challenge") > -1

  checkIfIsThanksModal = () => (window.location.href.indexOf("?customer_posted=true") > -1);

  // cookie_lifetime is in hours
  addCookie = (longterm = false) => {
    const { cookie_name, cookie_lifetime } = this.properties;
    const date = new Date();
    date.setTime(date.getTime() + ((longterm ? 2 * 30 * 24 : cookie_lifetime) * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${cookie_name}=true;${expires};path=/`;
  }

  showModal = () => {
    this.addCookie();
    this.elements.overlay.dataset.active = true
  };

  destroyModal = () => {
    this.parentElement.parentElement.removeChild(this.parentElement)
  }

  //
  // Handle Events
  //
  handleCloseButtonClick = ({ target }) =>
    (target === this.elements.overlay || this.elements.closeButton.contains(target)) &&
    this.destroyModal()

  handleFormSubmit = (e) => {
    e.preventDefault();
  }

}

customElements.define('popup-promo', PopupPromo);